import PageHeader from "../components/PageHeader";
import TermsAndConditions from "../components/TermsAndConditions";
import '../styles/about.css';

const TermsAndConditionsPage = ()=>{
    return (
        <div className="about-page">
            <PageHeader title="Terms And Conditions" />
            <div className="about-section">
                <TermsAndConditions/>
            </div>
        </div>
    )
}
export default TermsAndConditionsPage;